import { render, staticRenderFns } from "./mzjzlc.vue?vue&type=template&id=19a6be10&scoped=true&"
import script from "./mzjzlc.vue?vue&type=script&lang=js&"
export * from "./mzjzlc.vue?vue&type=script&lang=js&"
import style0 from "./mzjzlc.vue?vue&type=style&index=0&id=19a6be10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a6be10",
  null
  
)

export default component.exports